import {
  GET_PARTICIPANTS,
  ROLE_DRIVER_FILTRE_CHANGED,
  PAGE_CHANGED,
  PAGE_LIMIT_CHANGED,
  REMOVE_ERROR,
  RESET_SUCCESS_ACTION,
  RESET_CONFIG,
  SEARCH_PARTICIPANTS,
  ADD_PARTICIPANT,
  UPDATE_PARTICIPANT,
  GET_PARTICIPANTS_LIST_MORE,
  ROLE_USER_FILTRE_CHANGED,
} from './constants'

export const fetchParticipants = () => ({
  type: GET_PARTICIPANTS,
})

export const roleDriverFiltreChange = () => ({
  type: ROLE_DRIVER_FILTRE_CHANGED,
})

export const pageChanged = (offset) => ({
  type: PAGE_CHANGED,
  payload: { offset },
})

export const pageLimitChanged = (limit) => ({
  type: PAGE_LIMIT_CHANGED,
  payload: { limit },
})

export const getParticipantsMore = () => ({
  type: GET_PARTICIPANTS_LIST_MORE,
})

export const removeError = () => ({
  type: REMOVE_ERROR,
})

export const resetSuccessAction = () => ({
  type: RESET_SUCCESS_ACTION,
})

export const resetParticipantConfig = () => ({
  type: RESET_CONFIG,
})

export const onSearch = (search) => ({
  type: SEARCH_PARTICIPANTS,
  payload: { search },
})

export const createParticipant = (participant) => ({
  type: ADD_PARTICIPANT,
  payload: { participant },
})

export const updateParticipant = (payload, id) => ({
  type: UPDATE_PARTICIPANT,
  payload: { newParticipant: payload, id },
})

export const roleUserFiltreChange = () => ({
  type: ROLE_USER_FILTRE_CHANGED,
})
